import { useState } from 'react';
import { Icon } from './Icon.tsx';
import { wapsignApi } from '../features/meetings/api.ts';
import { dv } from '../i18n/dv.ts';

// Ecosystem jump: opens WapSign already signed in (one-time SSO handoff).
// Falls back to a plain link when the user has no WapSign account.
export function AppSwitcher({ variant }: { variant: 'header' | 'sidebar' }): JSX.Element {
  const [busy, setBusy] = useState(false);

  async function open(): Promise<void> {
    if (busy) return;
    setBusy(true);
    try {
      const url = await wapsignApi.handoff('/dashboard');
      window.location.href = url;
    } catch {
      window.location.href = 'https://sign.wapplify.app';
    }
  }

  if (variant === 'header') {
    return (
      <button
        type="button"
        onClick={() => void open()}
        disabled={busy}
        aria-label={dv.nav.wapsign}
        className="grid size-11 place-items-center rounded-full text-muted-foreground hover:text-foreground hover:bg-muted/70 disabled:opacity-50"
      >
        <Icon name="edit_square" size={20} />
      </button>
    );
  }
  return (
    <button
      type="button"
      onClick={() => void open()}
      disabled={busy}
      className="flex w-full items-center gap-3 rounded-full px-2.5 py-2 text-[0.92rem] text-muted-foreground hover:bg-muted/70 hover:text-foreground disabled:opacity-50"
    >
      <Icon name="edit_square" size={20} />
      <span>{dv.nav.wapsign}</span>
    </button>
  );
}
